export enum AxisLocation {
  Left = 0,
  Rigth = 1,
  Bottom = 2,
  Top = 3,
}
